import clsx from 'clsx';
import React, { FC, useEffect, useRef, useState } from 'react';
import { useAuth } from '../../../../app/contexts/AuthProvider';
import { Modal } from 'react-bootstrap-v5';
import moment from 'moment';
import ClientesService from '../../../../app/services/ClientesService';
import Storage from '../../../../app//utils/StorageUtils';
import UsuariosService from '../../../../app/services/UsuariosService';
import { IUsuario } from '../../../../app/interfaces/IUsuario';
import { IUsuarios } from '../../../../app/interfaces/IUsuarios';
import { useNotify } from '../../../../app/contexts/NotificacaoProvider';
// import { HeaderUserMenu } from '../../../partials'

const toolbarButtonMarginClass = 'ms-1 ms-lg-3', toolbarUserAvatarHeightClass = 'symbol-30px symbol-md-40px';

const Topbar: FC = () => {

  const { usuario } = useAuth();
  const { notifications, removeNotification, removeAllNotification } = useNotify();
  const [modal, setModal] = useState<boolean>(false);
  const [clientes, setClientes] = useState<any[]>([]);
  const [clienteSelecionado, setClienteSelecionado] = useState<number>(0);
  const [carregandoClientes, setCarregandoClientes] = useState<boolean>(false);
  const [busca, setBusca] = useState('');
  const [dropdownAberto, setDropdownAberto] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickFora = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setDropdownAberto(false);
        setBusca('');
      }
    };
    document.addEventListener('mousedown', handleClickFora);
    return () => document.removeEventListener('mousedown', handleClickFora);
  }, []);

  const clientesOrdenados = [...clientes].sort((a, b) =>
    (a.razaoSocial || '').localeCompare(b.razaoSocial || '', 'pt-BR')
  );

  const clientesFiltrados = clientesOrdenados.filter(c =>
    (c.razaoSocial || '').toLowerCase().includes(busca.toLowerCase())
  );

  const clienteNome = clientes.find(c => c.id === clienteSelecionado)?.razaoSocial || 'Selecione um cliente';

  const selecionarCliente = (id: number) => {
    setCarregandoClientes(true);
    setClienteSelecionado(id);
    setDropdownAberto(false);
    setBusca('');
    Storage.setUsuario({ ...usuario, clienteID: id } as IUsuario);
    UsuariosService.atualizar({ ...usuario, clienteID: id } as unknown as IUsuarios, () => {
      window.location.reload();
    });
  };

  useEffect(() => {
    setCarregandoClientes(true);

    if (usuario?.perfil === "Administrador" && usuario?.controlaClientes) {
      ClientesService.obterTodos((data) => {
        setClientes(data);
        setCarregandoClientes(false);
      });
    }
  }, [usuario]);

  useEffect(() => {
    if (usuario) {
      setClienteSelecionado(usuario.clienteID || 0);
    }
  }, [usuario]);


  return (
    <div className='d-flex align-items-stretch flex-shrink-0'>

      {usuario && usuario.controlaClientes && usuario.perfil !== "Master" && (
        <div className='form-control' style={{ border: 'none', position: 'absolute', left: '1%', width: 500, padding: 0, marginTop: '10px' }}>
          {carregandoClientes && (
            <div className='col-md-2 mt-2'>
              <span className='indicator-progress' style={{ display: 'block' }}>
                <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                Aguarde...
              </span>
            </div>
          )}

          {!carregandoClientes && (
            <div ref={dropdownRef} style={{ position: 'relative', width: '100%' }}>
              <div
                className='form-control d-flex align-items-center justify-content-between'
                style={{ cursor: 'pointer', userSelect: 'none', height: 38, fontSize: 14 }}
                onClick={() => { setDropdownAberto(v => !v); setBusca(''); }}
              >
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', flex: 1 }}>
                  {clienteNome}
                </span>
                <i className={`fas fa-chevron-${dropdownAberto ? 'up' : 'down'} ms-2`} style={{ flexShrink: 0, fontSize: 11, color: '#a1a5b7' }} />
              </div>

              {dropdownAberto && (
                <div style={{
                  position: 'absolute',
                  top: '100%',
                  left: 0,
                  zIndex: 1050,
                  background: '#fff',
                  border: '1px solid #e4e6ef',
                  borderRadius: 6,
                  boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
                  minWidth: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  marginTop: 4
                }}>
                  <div style={{ padding: '8px 8px 4px' }}>
                    <input
                      autoFocus
                      type='text'
                      className='form-control form-control-sm'
                      placeholder='Buscar cliente...'
                      value={busca}
                      onChange={e => setBusca(e.target.value)}
                      onClick={e => e.stopPropagation()}
                    />
                  </div>
                  <div style={{ overflowY: 'auto', maxHeight: 260 }}>
                    <div
                      style={{ padding: '7px 12px', cursor: 'pointer', fontSize: 13, color: '#a1a5b7' }}
                      onMouseEnter={e => (e.currentTarget.style.background = '#f5f8fa')}
                      onMouseLeave={e => (e.currentTarget.style.background = '')}
                      onClick={() => selecionarCliente(0)}
                    >
                      Selecione um cliente
                    </div>
                    {clientesFiltrados.map(c => (
                      <div
                        key={c.id}
                        style={{
                          padding: '7px 12px',
                          cursor: 'pointer',
                          fontSize: 13,
                          background: c.id === clienteSelecionado ? '#e8f0fe' : '',
                          fontWeight: c.id === clienteSelecionado ? 600 : 400
                        }}
                        onMouseEnter={e => { if (c.id !== clienteSelecionado) e.currentTarget.style.background = '#f5f8fa'; }}
                        onMouseLeave={e => { if (c.id !== clienteSelecionado) e.currentTarget.style.background = ''; }}
                        onClick={() => selecionarCliente(c.id)}
                      >
                        {c.razaoSocial}
                      </div>
                    ))}
                    {clientesFiltrados.length === 0 && (
                      <div style={{ padding: '7px 12px', fontSize: 13, color: '#a1a5b7' }}>
                        Nenhum cliente encontrado
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      )}
      <Modal size='xl' centered={true} show={modal} onHide={() => setModal(false)}>
        <div className="modal-content" style={{ backgroundColor: '#F4F5F7' }}>
          <div className="modal-header">
            <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase' }}>Notificações</h5>
            <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
              <i onClick={() => setModal(false)} className="fas fa-times" style={{ color: '#5E6397' }}></i>
            </div>
          </div>
          <div className="modal-body">
            <div className="row">
              {notifications.length > 0 && <div className='col-md-12'>
                <button className='btn btn-success' onClick={() => removeAllNotification()}>Limpar Mensagens</button>
              </div>}
              {!notifications || notifications.length == 0 && <p style={{ fontSize: '14px', fontWeight: 300, textAlign: 'left' }}>Não existe notificações para ser visualizada</p>}
              {notifications.map((item) => (
                <div onClick={() => removeNotification(item.id)} key={item.id} className='col-md-12 mt-4' style={{ display: 'flex', alignItems: 'center' }}>
                  {item.dataInsercao && <p style={{ width: '150px', margin: '0', marginRight: '10px' }}>{moment(item.dataInsercao).format('DD/MM/YYYY HH:mm:ss')}</p>}
                  <p style={{ fontSize: '14px', fontWeight: 600, textAlign: 'left', margin: '0', marginRight: '10px' }}>{item.mensagem}</p>
                  <i className="fas fa-circle" style={{ color: '#5E6397' }}></i>
                </div>
              ))}
            </div>
          </div>
        </div>
      </Modal>
      <div className={clsx('d-flex align-items-center', toolbarButtonMarginClass)} id='kt_header_user_menu_toggle'>
        <div
          className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          data-kt-menu-trigger='click'
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
          data-kt-menu-flip='bottom'
          style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <img style={{
            marginRight: '5px'
          }} src='/media/avatars/blank.png' alt='metronic' />
          <span className="fw-bolder">{usuario?.nome}</span>
          <i className={notifications.length > 0 ? 'fa fa-bell bell-ring' : 'fa fa-bell'} onClick={() => setModal(true)} style={{ color: notifications.length > 0 ? 'red' : '#005E96', fontSize: '24px', marginLeft: '5px' }}></i>
        </div>
        {/* <HeaderUserMenu /> */}
      </div>
    </div>
  )
}

export { Topbar };



